import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getRole } from '../components/Apicall';
import './AccessDenied.css';

const AccessDenied = () => {
  const navigate = useNavigate();
  const role = getRole();

  useEffect(() => {
    localStorage.clear();
    const timer = setTimeout(() => {
      navigate('/'); // Redirect to login page after 2 seconds
    }, 2000);
    return () => clearTimeout(timer);
  }, [navigate]);

  const handleDashboardClick = () => {
    if (role === '5') {
      navigate('/dashboard');
    } else {
      navigate('/vendors');
    }
  };

  return (
    <div className="access-denied-container">
      <div className="access-denied-content">
        <div className="access-denied-icon">🚫</div>
        <h1>Access Denied</h1>
        <h2>Unauthorized Access</h2>
        <p>You don't have permission to access this page. Please contact your administrator if you believe this is a mistake.</p>
        <div className="access-denied-actions">
          <button 
            className="dashboard-link" 
            onClick={handleDashboardClick}
          >
            Go to {role === '5' ? 'Dashboard' : 'Vendors'}
          </button>
          <button 
            className="back-link" 
            onClick={() => window.history.back()}
          >
            Go Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied; 